class Checkout {
    constructor(rootEl){
        this.$root = rootEl;
        this.$form = this.$root.find('.order-form');

        if( this.$form.length <= 0 ) return;

        this.$delivery_parts            = this.$root.find('.final-price.delivery, .address-selection');
        this.$restaurant_parts          = this.$root.find('.restaurant-selection, .delivery-discount');

        this.$summary                   = this.$root.find('.summary-wrapper');
        this.$submit                    = this.$root.find('.finish-order');
        this.$errorPopup                = jQuery('.error-popup');

        this.receiveAt                  = 'delivery';
        this.deliveryPrice              = 0;

        this.$discountPopup             = jQuery('.discount-popup');
        this.discountPopupDismissed     = false;

        this.canBeFinished              = this.$root.find('.error-cannot-be-finished').length <= 0;

        this.init();
        this.update();
    }

    init(){
        this.initReceiveAt();
        this.initProductList();
        this.initSubmitBtn();
        this.initDiscountPopup();
        this.initAdditional();
    }

    initReceiveAt(){
        let that = this;

        this.deliveryPrice = parseFloat(this.$root.find('#delivery_address').data('delivery-price')).toFixed(2);

        this.$root.on('change', 'input[name="receive_at"]', function(){
            that.receiveAt = jQuery(this).val();
            that.update();
        });

        this.$root.on('change', 'input[name="chosen_address"], input[name="chosen_restaurant"]', function(){
            that.update();
        });
    }

    initProductList(){
        let that = this;

        this.$root.on('click', ".remove-order-product", function (e) {
            e.preventDefault();

            let $e      = jQuery(this);
            let $row    = $e.parents('.product-row');
            let id      = $row.data('product-id');
            let url     = '/removeProduct/' + id;

            jQuery.get(url, function (data, status) {
                $row.remove();
                that.reload();
            });
        });

        this.$root.on('click', '.quantity-button:not(.chopsticks-fork)', function(){
            let $row    = jQuery(this).parents('.product-row');

            //let qty     = parseInt($row.find('.input-count').val(), 10);
            let id      = $row.data('product-id');

            let action  = jQuery(this).hasClass('quantity-up') ? 'addProduct' : 'removeProduct';
            let url     = '/' + action + '/' + id + '/1';

            jQuery.ajax({
                type: 'GET',
                url: url,
                beforeSend: function () {
                    $row.addClass('loading');
                },
                success: function (response) {
                    if (response) {
                        that.update();
                    }
                },
                complete: function () {
                    $row.removeClass('loading');
                }
            });
        });
    }

    initSubmitBtn(){
        let that = this;

        this.$submit.on('click', function() {
            let err = 
                (that.receiveAt == 'delivery' && that.$root.find('input[name="chosen_address"]:checked').length <= 0) ||
                (that.receiveAt == 'restaurant' && that.$root.find('input[name="chosen_restaurant"]:checked').length <= 0);

            if(err){
                that.$errorPopup.addClass('popup_show');

                jQuery("html, body").animate({
                    scrollTop : 0
                }, 700);

                return false;
            }

            if( that.$discountPopup.length > 0 ){
                if(!that.discountPopupDismissed) {
                    that.$discountPopup.addClass('popup_show');
                    return false;
                }
            }
        });
    }

    initDiscountPopup(){
        if(this.$discountPopup.length <= 0) return;

        let that = this;

        let $dismiss    = this.$discountPopup.find('.discount-popup-dismiss');
        let $apply      = this.$discountPopup.find('.discount-popup-apply');

        $dismiss.on('click', function(){
            that.$discountPopup.removeClass('popup_show');
            that.discountPopupDismissed = true;
        });

        $apply.on('click', function(){
            that.$discountPopup.removeClass('popup_show');
            that.applyCode( jQuery(this).data('code') );
        });
    }

    initAdditional(){
        jQuery('.cart-products').mCustomScrollbar({
            theme: 'dark'
        });
    }

    update(){
        let that = this;

        this.$delivery_parts.toggleClass('hidden', this.receiveAt != 'delivery');
        this.$restaurant_parts.toggleClass('hidden', this.receiveAt == 'delivery');
        this.$summary.find('.summary-entry span').css({opacity: 0});

        let address_id      = this.$root.find('input[name="chosen_address"]:checked').val() || 0;
        let restaurant_id   = this.$root.find('input[name="chosen_restaurant"]:checked').val() || 0;

        jQuery.ajax({
            type: 'GET',
            url: '/checkoutSummary',
            data: {
                'receiveAt': this.receiveAt,
                'addressId': address_id,
                'restaurantId': restaurant_id
            },
            success: function (response) {
                if (response) {
                    that.$summary.html(response);
                    
                    let pp = parseFloat(that.$summary.find('.product-total-price span').text());
                    if ((pp >= 10 && !that.canBeFinished) || (pp < 10 && that.canBeFinished)){
                        window.location.reload();
                    }
                }
            }
        });
    }

    reload(){
        window.location.reload();
    }
    
    applyCode(code){
        if( jQuery('.promocode-input').length <= 0 ) return;

        jQuery('.promocode-input').val(code);
        jQuery('.promocode-btn').click();
    }
}

export default Checkout;